import Fuse from "fuse.js"

export const employeeFuseConfig = {
  keys: ["name"],
  shouldSort: true,
  threshold: 0.499999,
  includeScore: true,
  includeMatches: false,
}

export const getAutosuggestOptions = (
  inputValue,
  allOptions,
  options = employeeFuseConfig
) => {
  const inputLength = inputValue.length

  const fuse = new Fuse(allOptions, options)
  const filteredRecords = fuse.search(inputValue).map((result) => result.item)

  /* istanbul ignore next */
  return inputLength === 0 ? [] : filteredRecords
}
